module.exports = __webpack_public_path__ + "img/Hero.59bf38d6.svg";